import React from 'react'
import { Route, Routes } from 'react-router-dom'
import { FounderMarket } from './views/FounderMarket'
import { PageTitle } from '../../../_metronic/layout/core'
import { useIntl } from 'react-intl'
import { FounderMarketBreadCrumb } from './core/_constants'
import FounderMarketDetail from './views/FounderMarketDetail'
import { ToolTipUI } from '../widgets/components/UI/ToolTipUI'
import './styles/FounderMarket.scss'

const FounderMarketRoutes = () => {
  const { formatMessage } = useIntl()
  const { FounderMarketBreadCrumbs, FounderMarketToolsBreadCrumbs } = FounderMarketBreadCrumb()

  return (
    <div className='mt-3 px-6'>
      <Routes>
        <Route
          index
          element={
            <div style={{ position: 'relative' }}>
              <PageTitle
                breadcrumbs={FounderMarketToolsBreadCrumbs}
                description={formatMessage({ id: 'Founder Market' })}
              >
                {formatMessage({ id: 'Founder Market' })}
              </PageTitle>
              <div className='founder-market-tooltip'>
                <ToolTipUI
                  tooltipText={formatMessage({
                    id: 'Find the best deals for most sought after business tools',
                  })}
                />
              </div>
              <FounderMarket />
            </div>
          }
        />
        <Route
          path='/:tabName/:dealId'
          element={
            <div style={{ position: 'relative' }}>
              <PageTitle
                breadcrumbs={FounderMarketBreadCrumbs}
                description={formatMessage({ id: 'Tools & Platform Offers' })}
              >
                {formatMessage({ id: 'Founder Market' })}
              </PageTitle>
              <div className='founder-market-detail-tooltip'>
                <ToolTipUI
                  tooltipText={formatMessage({
                    id: 'Find the best deals for most sought after business tools',
                  })}
                />
              </div>
              <FounderMarketDetail />
            </div>
            // <>
            //   <div className='mb-8 mt-n3'>
            //     <div className='d-flex gap-2 align-items-center mb-4'>
            //       <h1 className='fs-4 m-0'>{formatMessage({ id: 'Productivity Deal' })}</h1>
            //       <ToolTipUI tooltipText={'Productivity Deals'} />
            //     </div>
            //     <Link to={'../'} className='bg-transparent text-primary border-0 font-size-12'><i className="fa-solid fa-arrow-left pe-2 font-size-12" style={{ color: '#4776e6' }}></i>{formatMessage({ id: 'Go back' })}</Link>
            //   </div>
            //   <FounderMarketDetail />
            // </>
          }
        />
      </Routes>
    </div>
  )
}

export default FounderMarketRoutes
